import { IScheduledReport } from '@api/models/analytics.model';
import { ICamera, IUser } from '@api/models';
import { Table } from '@hyperflake/react-ui-library';
import { ProgressReportTypeEnum } from '@api/enum';
import moment from 'moment';
import { Link } from 'react-router-dom';

interface ScheduledReportsListProps {
    isLoading: boolean;
    reports: IScheduledReport[];
}

const ScheduledReportsList = ({ isLoading, reports }: ScheduledReportsListProps) => {
    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover={false}
            isLoading={isLoading}
            data={reports}
            columns={[
                { header: 'ID' },
                { header: 'Date' },
                { header: 'Camera' },
                { header: 'User' },
                { header: 'Type' },
            ]}
            renderRow={(row) => (
                <Table.Row key={row._id}>
                    <Table.Cell>{row._id}</Table.Cell>

                    <Table.Cell>{moment(row.createdAt).format('HH:mm A - DD MMM YYYY')}</Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.camera as ICamera).client}/projects/${
                                (row.camera as ICamera).project
                            }/cameras/${(row.camera as ICamera)._id}/edit-camera`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.camera as ICamera)?.name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.user as IUser).client}/users/${(row.user as IUser)._id}/edit-user`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.user as IUser)?.name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>{ProgressReportTypeEnum[row.type]}</Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default ScheduledReportsList;
